import config from 'react-global-configuration';
import { isSensitiveRoute } from '@utils/sensitiveRoutes';

// eslint-disable-next-line no-undef
let prodEnv = process.env.NODE_ENV === 'production';

const analyticsEnabled = () => prodEnv && !isSensitiveRoute();
export const MIXPANEL_OPTIONS = {
  api_host: 'https://api-eu.mixpanel.com',
  record_console: false,
};
let mixpanelPromise;
let initialized = false;

const loadMixpanel = () => {
  if (!analyticsEnabled()) return Promise.resolve(null);

  if (!mixpanelPromise) {
    mixpanelPromise = import('mixpanel-browser')
      .then(module => module.default)
      .catch(error => {
        mixpanelPromise = null;
        throw error;
      });
  }

  return mixpanelPromise;
};

const runWithMixpanel = (callback) => {
  if (!analyticsEnabled()) return;

  loadMixpanel()
    .then(mixpanel => {
      if (!mixpanel || !analyticsEnabled()) return;
      callback(mixpanel);
    })
    .catch(error => {
      console.error('mixpanel error:', error);
    });
};

export const withoutSensitiveTaskData = (props) => {
  if (!props?.task) return props;

  const task = { ...props.task };
  delete task.cookies;

  return { ...props, task };
};

const actions = {
  init: () => {
    try {
      runWithMixpanel(mixpanel => {
        if (initialized) return;
        mixpanel.init(config.get('mixpanelToken'), MIXPANEL_OPTIONS);
        initialized = true;
      });
    } catch (error) {
      console.error('mixpanel error:', error);
    }
  },
  identify: (id) => {
    try {
      runWithMixpanel(mixpanel => {
        mixpanel.identify(id);
      });
    } catch (error) {
      console.error('mixpanel error:', error);
    }
  },
  alias: (id) => {
    try {
      runWithMixpanel(mixpanel => {
        mixpanel.alias(id);
      });
    } catch (error) {
      console.error('mixpanel error:', error);
    }
  },
  track: (title, props) => {
    try {
      runWithMixpanel(mixpanel => {
        mixpanel.track(title, withoutSensitiveTaskData(props));
      });
    } catch (error) {
      console.error('mixpanel error:', error);
    }
  }
};

export default actions;
